import React, { forwardRef, HTMLProps, useState } from 'react'
import { Direction } from '../utils/constants'
import { scroll } from './ArrowNavigation'
import { twMerge } from 'tailwind-merge'

interface HorizontalScrollProps extends HTMLProps<HTMLDivElement> {
  children: React.ReactNode
  wrapperClasses?: string
}

const HorizontalScroll = forwardRef(
    ({ children, wrapperClasses, style }: HorizontalScrollProps, ref: any) => {
        const [initialXPosition, setInitialXPosition] = useState(0)

        const onMouseDown = (e: { clientX: React.SetStateAction<number> }) => {
            if (ref.current) {
                ref.current.style.cursor = 'grabbing'
                ref.current.style.userSelect = 'none'
                setInitialXPosition(e.clientX)
            }
        }
        const onMouseUp = (e: { clientX: number }) => {
            if (ref.current) {
                ref.current.style.cursor = 'auto'
                const dx = initialXPosition - e.clientX
                scroll(dx > 0 ? Direction.RIGHT : Direction.LEFT, ref)
            }
        }
        return (
            <div
                className={twMerge(
                    'flex overflow-x-auto snap-x snap-mandatory w-full no-scrollbar scroll-smooth',
                    wrapperClasses,
                )}
                ref={ref}
                onMouseDown={onMouseDown}
                onMouseUp={onMouseUp}
                style={style}
            >
                {children}
            </div>
        )
    },
)

HorizontalScroll.displayName = 'HorizontalScroll'
export default HorizontalScroll
